import { useMemo } from 'react';
import { useQuery } from 'react-query';

const getServiceFunc = (service) => {
  switch (typeof service) {
    case 'function':
      return service;
    default:
      return service.getOne;
  }
};

export const createGetOneHook = (service, keyId, name, mapPayload = v => v) => {
  return (params, config = {}) => {
    const relatedKey = useMemo(() => params?.[keyId], [params]);

    const queryConfig = useMemo(() => {
      return { enabled: !!relatedKey, ...config };
    }, [config, relatedKey]);

    return useQuery([name, relatedKey], async () => {
      const { data } = await getServiceFunc(service)(relatedKey);
      return {
        data: mapPayload(data)
      };
    }, queryConfig);
  };
};
